import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    eventoId: 0,

    transferenciasEvolucion: [],
    transferenciasEvolucionPeriodos: [],
    transferenciasEvolucionMax: 0,
    transferenciasEvolucionStep: 0,
    transferenciasPeriodos: [],

    transferenciasResultados: [],
    transferenciasResultadosPeriodos: [],
    transferenciasResultadosMax: 0,
    transferenciasResultadosStep: 0,

    transferenciasParticipantes: [],

    cadenasGenExpertos: [],

    clasificacionPuntosVentaGenExpertos: [],
    clasificacionPuntosVentaGenExpertosLabels: [],
    clasificacionPuntosVentaGenExpertosColors: [],
    clasificacionPuntosVentaGenExpertosData: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, eventoId = 0) {
        state.eventoId = eventoId;

        state.transferenciasEvolucion = [];
        state.transferenciasEvolucionPeriodos = [];
        state.transferenciasEvolucionMax = 0;
        state.transferenciasEvolucionStep = 0;
        state.transferenciasPeriodos = [];
        
        state.transferenciasResultados = [];
        state.transferenciasResultadosPeriodos = [];
        state.transferenciasResultadosMax = 0;
        state.transferenciasResultadosStep = 0;


        state.transferenciasParticipantes = [];
        
        state.cadenasGenExpertos = [];
        state.clasificacionPuntosVentaGenExpertos = [];
        state.clasificacionPuntosVentaGenExpertosLabels = [];
        state.clasificacionPuntosVentaGenExpertosColors = [];
        state.clasificacionPuntosVentaGenExpertosData = [];
    },
    'SET_TRANSFERENCIAS_PERIODOS' (state, transferenciasPeriodos) {
        /* Tabla */
        state.transferenciasPeriodos = transferenciasPeriodos;

        /* Gráfico */
        if (transferenciasPeriodos) {
            state.transferenciasEvolucionMax = Math.max(...transferenciasPeriodos.map(t => t.importeAcreditadas));
            state.transferenciasEvolucionMax = Math.ceil(state.transferenciasEvolucionMax / 10000000) * 10000000;

            state.transferenciasEvolucionStep = Math.ceil(state.transferenciasEvolucionMax / 1000 / 10) * 1000;
        }

        let transferenciasAcreditadas = {
            label: 'Acreditadas',
            backgroundColor: 'transparent',
            borderColor: '#0000FF',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };

        let transferenciasRechazadas = {
            label: 'Rechazadas',
            backgroundColor: 'transparent',
            borderColor: '#E74C3C',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        };

        if (transferenciasPeriodos) {
            transferenciasPeriodos.forEach(periodo => {
                console.log(periodo)
                state.transferenciasEvolucionPeriodos.push(moment.utc(periodo.periodo).format('MM/YYYY'));

                transferenciasAcreditadas.data.push(periodo.importeAcreditadas);
                transferenciasRechazadas.data.push(periodo.importeRechazadas);
            });
        }
        state.transferenciasEvolucion.push(transferenciasAcreditadas);
        state.transferenciasEvolucion.push(transferenciasRechazadas);
        console.log(state.transferenciasEvolucion);
    },
    'SET_TRANSFERENCIAS_RESULTADOS' (state, transferenciasResultados) {
        if (transferenciasResultados) {
            // state.transferenciasResultadosMax = transferenciasResultados.max(t => t.importe);
            state.transferenciasResultadosMax = Math.max(...transferenciasResultados.map(t => t.acreditadas + t.rechazadas));
            state.transferenciasResultadosMax = Math.ceil(state.transferenciasResultadosMax / 1000) * 1000;
            state.transferenciasResultadosStep = Math.ceil(state.transferenciasResultadosMax / 100 / 10) * 100;
        }

        let transferenciasAprobadas = {
            label: 'Acreditadas',
            backgroundColor: '#16A085',
            borderColor: '#16A085',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        }
        let transferenciasRechazadas = {
            label: 'Rechazadas',
            backgroundColor: '#E74C3C',
            borderColor: '#E74C3C',
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: []
        }

        if (transferenciasResultados) {
            transferenciasResultados.forEach(periodo => {
                state.transferenciasResultadosPeriodos.push(moment.utc(periodo.periodo).format('MM/YYYY'));

                transferenciasAprobadas.data.push(periodo.acreditadas);
                transferenciasRechazadas.data.push(periodo.rechazadas);
            });
        }

        state.transferenciasResultados.push(transferenciasAprobadas);
        state.transferenciasResultados.push(transferenciasRechazadas);
    },
    'SET_TRANSFERENCIAS_PARTICIPANTES' (state, transferenciasParticipantes) {
        state.transferenciasParticipantes = transferenciasParticipantes;
    },

    'SET_CADENAS_GEN_EXPERTOS' (state, cadenasGenExpertos) {
        if (cadenasGenExpertos) {
            state.cadenasGenExpertos = cadenasGenExpertos
                .sort((a, b) => (a.cantidad < b.cantidad) ? 1 : ((b.cantidad < a.cantidad) ? -1 : 0));
        }
    },
    'SET_CLASIFICACION_PUNTOS_VENTA_GEN_EXPERTOS' (state, clasificacion) {
        state.clasificacionPuntosVentaGenExpertosColors = [ 
            '#0000FF',
            '#41B883', 
            '#E46651', 
            '#FAFA05' 
        ];

        if (clasificacion) {
            let cadenas = clasificacion[0].cadenas;
            let independientes = clasificacion[0].independientes;

            state.clasificacionPuntosVentaGenExpertos.push({
                nombre: 'CADENAS',
                color: '#0000FF',
                cantidad: cadenas,
                pjeParticipacion: helpers.methods.roundToTwo((cadenas / (cadenas + independientes) * 100)),
            })

            state.clasificacionPuntosVentaGenExpertos.push({
                nombre: 'INDEPENDIENTES',
                color: '#41B883',
                cantidad: independientes,
                pjeParticipacion: helpers.methods.roundToTwo((independientes / (cadenas + independientes) * 100)),
            })

            state.clasificacionPuntosVentaGenExpertosLabels = state.clasificacionPuntosVentaGenExpertos.map(t => t.nombre.trim());
            state.clasificacionPuntosVentaGenExpertosData = state.clasificacionPuntosVentaGenExpertos.map(t => t.pjeParticipacion);
        }
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, eventoId) {
        commit('INICIALIZAR', eventoId);
    },
    getTransferenciasPeriodos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${state.eventoId}/status/transferencias/periodo`) 
                .then(res => {
                    commit('SET_TRANSFERENCIAS_PERIODOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getTransferenciasResultados ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${state.eventoId}/status/transferencias/resultados`) 
                .then(res => {
                    commit('SET_TRANSFERENCIAS_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getTransferenciasParticipantes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${state.eventoId}/status/transferencias/participantes`) 
                .then(res => {
                    commit('SET_TRANSFERENCIAS_PARTICIPANTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getCadenasGenExpertos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${state.eventoId}/status/gen-expertos/cadenas`) 
                .then(res => {
                    commit('SET_CADENAS_GEN_EXPERTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getClasificacionPuntosVentaGenExpertos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${state.eventoId}/status/gen-expertos/puntos-venta-clasificacion`) 
                .then(res => {
                    commit('SET_CLASIFICACION_PUNTOS_VENTA_GEN_EXPERTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}